<script>
    export let size = 24
    export let color = '#C5281C'
    export let style = ''
    export let title = null
</script>

<svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${size}`}
    height={`${size}`}
    viewBox="0 0 512 512"
    {style}
>
    {#if title}
        <title>{title}</title>
    {/if}
    <path
        d="M336,208V113a80,80,0,0,0-160,0v95"
        style="fill:none;stroke:{color};stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"
    ></path>
    <rect
        x="96"
        y="208"
        width="320"
        height="272"
        rx="48"
        ry="48"
        style="fill:none;stroke:{color};stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"
    ></rect>
</svg>
